import React from 'react';

import { StatusMascot } from 'components/Mascot';
import { useUserStore } from 'store/useUserStore';

import EmployeeTimeClockLanding from './EmployeeTimeClockLanding';

const EmployeeTimeClock: React.FC<unknown> = () => {
  const loginUser: any = useUserStore(state => state.user);

  if (loginUser?.companyInfo?.blockWebsitePunch) {
    return (
      <>
        {/* <Flex
          p="4"
          justifyContent="center"
          alignItems="center"
          fontWeight="600"
          height="50%"
          textAlign="center"
          fontSize="md"
        >
          Clocking in/out on the web application has been disabled by your administrator. <br />
          Please use the mobile app for clocking in/out. If you'd like to clock in/out on the web app, please contact
          your administrator to enable this feature.
        </Flex> */}

        <StatusMascot
          wrapperProps={{ height: '50vh' }}
          type="time"
          title="Clocking in/out on the web application has been disabled."
          description=" Please use the mobile app for clocking in/out. If you'd like to clock in/out on the web app, please contact your administrator to enable this feature."
        />
      </>
    );
  }

  return <EmployeeTimeClockLanding />;
};
export default EmployeeTimeClock;
